import ThirdPartyNotificationListPage from "./pages/ThirdPartyNotificationListPage";

export const thirdPartyNotificationRoutes = () => [
  {
    name: "ThirdPartyNotificationListPage",
    path: 'third-party-notification',
    component: ThirdPartyNotificationListPage
  }
];
